import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
let KickoutApi = class KickoutApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        this.getKickoutrecords = (params) => {
            const url = this.urls.getKickoutrecords;
            return this.http.get({
                url,
                params,
            });
        };
    }
};
KickoutApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.SystemUrls)),
    __metadata("design:paramtypes", [Object, Object])
], KickoutApi);
export { KickoutApi };
